














































































































import { Component, Vue } from 'vue-property-decorator';

import { NfreshClient, curNfreshClient } from '@/services/NfreshClient';
import { Probe, ProbeReading } from '@/types/nfresh';

import SectionHeader from '@/components/SectionHeader.vue';
import KeyValue from '@/components/KeyValue.vue';
import VueError from '@/components/VueError.vue';
import Loading from '@/components/Loading.vue'; 
import Success from '@/components/Success.vue'; 

import TimestampAgo from '@/components/TimestampAgo.vue';
import NfreshReadingRow from '@/components/nfresh/NfreshReadingRow.vue';
import NfreshReadingRowMobile from '@/components/nfresh/NfreshReadingRowMobile.vue';

@Component({
  components: {
    SectionHeader,
    KeyValue,
    VueError,
    Success,
    TimestampAgo,
    Loading,
    NfreshReadingRow,
    NfreshReadingRowMobile
  },
})
export default class NfreshSingleProbe extends Vue {

  probe:Probe = {} as Probe;
  readingList:ProbeReading[] = [];

  httpBusyProbe:boolean = false;
  httpBusyReadings:boolean = false;
  
  error:string = '';

  // internal dependencies
  private nfreshClient:NfreshClient = curNfreshClient;

  async mounted() {

    this.refreshStatus();
    this.refreshReadings();
  }

  async refreshStatus() {

    this.httpBusyProbe = true;

    const reply = await this.nfreshClient.getProbe({deviceId: this.$route.params.deviceId});

    this.httpBusyProbe = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(reply.errorMsg)
      return this.error = `Unable to retrieve probe ${this.$route.params.id}: ${reply.errorMsg}`;

    this.probe = reply.probe!;
  }

  async refreshReadings() {

    this.httpBusyReadings = true;

    const reply = await this.nfreshClient.getProbeLatestReadings({deviceId: this.$route.params.deviceId, limit: 50});

    this.httpBusyReadings = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(reply.errorMsg)
      return this.error = `Unable to retrieve probe readings for ${this.$route.params.id}: ${reply.errorMsg}`;

    this.readingList = reply.readingList!;
  }

  get showReadings():boolean {
    return !this.httpBusyReadings && this.readingList.length > 0;
  }

  get showProbe():boolean {
    return !this.httpBusyProbe && this.probe && this.probe.deviceId !== undefined;
  }

  get statusTopIconList():object[] {

    return [
      {name:'arrow-left', title:'back to probe list', event:'probe-list'},
      {name:'sync-alt', title:'reload status', event:'refresh-status'},
      {name:'external-link-alt', title:'device info', event:'device-page'}
    ];
  }

  get readingsTopIconList():object[] {

    return [
      {name:'sync-alt', title:'reload readings', event:'refresh-readings'},
    ];
  }

  get firmwareVersion() {
    return this.probe.status ? this.probe.status.firmwareVersion : '1.0';
  }

  navigateTo(dest:'probe-list'|'device-page') {

    switch(dest) {
      case 'probe-list': this.$router.push({ name: 'applications-nfresh-probes'}); break;
      case 'device-page': this.$router.push({ name: 'device', params: { deviceId:this.probe.deviceId }}); break;
    }
  }

}
